import React, { createContext, useState, useContext } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState('');

  return (
    <SessionContext.Provider value={{ sessionExpiredMessage, setSessionExpiredMessage }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
